var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.onboarding)?_c('appointment-onboarding-view',{attrs:{"offline":_vm.canOffline}}):_c('appointments-settings-list',{attrs:{"offline":_vm.canOffline}})}
var staticRenderFns = []

export { render, staticRenderFns }